<template>
	<div class="card">
		<div class="card__title">
			<h3>Auditoría</h3>
		</div>
		<div class="card__content">
			<div class="table-responsive">
				<vue-good-table :columns="columns" :pagination-options="{
					enabled: true,
					perPage: 10,
					perPageDropdown: dropDown,
					nextLabel: 'siguiente',
					prevLabel: 'anterior',
					rowsPerPageLabel: 'Registros por página',
					ofLabel: 'de',
					allLabel: 'Todo',
					dropdownAllowAll: true
				}" :rows="registros" :search-options="{
	enabled: true,
	placeholder: 'Buscar...'
}" styleClass="vgt-table vgt-table--sticky">
				</vue-good-table>
			</div>
		</div>
	</div>
</template>
  
<script>
export default {
	props: {
		dropDown: {
			required: false,
			default: function () {
				return [];
			}
		},
		path: {
			type: String,
			required: false,
			default: 'auditorias'
		},
		modulo: {
			type: String,
			required: true,
		},
		identificacion: {
			required: true,
		},
	},
	data: function () {
		return {
			registros: [],
			columns: [
				{
					label: 'Código',
					field: 'codigo',
					filterable: false,
				},
				{
					label: 'Fecha',
					field: 'fecha',
					filterable: false,
				},
				{
					label: 'Usuario',
					field: 'usuario.nombre',
					filterable: false,
				},
				{
					label: 'Evento',
					field: 'evento_parse',
					filterable: false,
				},
				{
					label: 'Observación',
					field: 'observacion',
					filterable: false,
				}
			],
			form: {
				modulo: this.modulo,
				identificacion: this.identificacion,
			}
		}
	},
	methods: {
		cargarAuditoria: function () {
			let urlApi = `${url}/${this.path}`;
			this.registros.splice(0, this.registros.length);
			axios
				.get(urlApi, {
					params: this.form
				})
				.then(response => {
					let registros = response.data;
					this.registros = [...registros];
				})
				.catch(error => {
					swal('Error', 'Hubo un error al cargar los registros', 'error');
				});
		},
	},
	mounted: function () {
		this.cargarAuditoria();
	}
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/auditorias/Auditoria.vue